import { render, staticRenderFns } from "./EventLandingHeaderContent.vue?vue&type=template&id=6a28f9f2&lang=pug"
import script from "./EventLandingHeaderContent.vue?vue&type=script&lang=js"
export * from "./EventLandingHeaderContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports